/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createConcept = /* GraphQL */ `mutation CreateConcept(
  $input: CreateConceptInput!
  $condition: ModelConceptConditionInput
) {
  createConcept(input: $input, condition: $condition) {
    id
    accountID
    name
    description
    logo
    type
    location
    precedence
    longitude
    latitude
    contactWhatsApp
    contactPhoneNumber
    contactEmail
    enableOhipIntegration
    ohipClientId
    ohipClientSecret
    ohipAuthUrl
    ohipApiBaseUrl
    ohipHotelId
    ohipAppKey
    ohipEnterpriseId
    ohipExternalSystem
    ohipScope
    ohipUsername
    ohipPassword
    ohipGrantType
    senderEmail
    whatsappToken
    whatsappApiUrl
    whatsappPhoneId
    autoReplyEnabled
    autoReplyText
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateConceptMutationVariables,
  APITypes.CreateConceptMutation
>;
export const updateConcept = /* GraphQL */ `mutation UpdateConcept(
  $input: UpdateConceptInput!
  $condition: ModelConceptConditionInput
) {
  updateConcept(input: $input, condition: $condition) {
    id
    accountID
    name
    description
    logo
    type
    location
    precedence
    longitude
    latitude
    contactWhatsApp
    contactPhoneNumber
    contactEmail
    enableOhipIntegration
    ohipClientId
    ohipClientSecret
    ohipAuthUrl
    ohipApiBaseUrl
    ohipHotelId
    ohipAppKey
    ohipEnterpriseId
    ohipExternalSystem
    ohipScope
    ohipUsername
    ohipPassword
    ohipGrantType
    senderEmail
    whatsappToken
    whatsappApiUrl
    whatsappPhoneId
    autoReplyEnabled
    autoReplyText
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateConceptMutationVariables,
  APITypes.UpdateConceptMutation
>;
export const deleteConcept = /* GraphQL */ `mutation DeleteConcept(
  $input: DeleteConceptInput!
  $condition: ModelConceptConditionInput
) {
  deleteConcept(input: $input, condition: $condition) {
    id
    accountID
    name
    description
    logo
    type
    location
    precedence
    longitude
    latitude
    contactWhatsApp
    contactPhoneNumber
    contactEmail
    enableOhipIntegration
    ohipClientId
    ohipClientSecret
    ohipAuthUrl
    ohipApiBaseUrl
    ohipHotelId
    ohipAppKey
    ohipEnterpriseId
    ohipExternalSystem
    ohipScope
    ohipUsername
    ohipPassword
    ohipGrantType
    senderEmail
    whatsappToken
    whatsappApiUrl
    whatsappPhoneId
    autoReplyEnabled
    autoReplyText
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteConceptMutationVariables,
  APITypes.DeleteConceptMutation
>;
export const createUserConcepts = /* GraphQL */ `mutation CreateUserConcepts(
  $input: CreateUserConceptsInput!
  $condition: ModelUserConceptsConditionInput
) {
  createUserConcepts(input: $input, condition: $condition) {
    id
    defaultConcept
    concepts
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserConceptsMutationVariables,
  APITypes.CreateUserConceptsMutation
>;
export const updateUserConcepts = /* GraphQL */ `mutation UpdateUserConcepts(
  $input: UpdateUserConceptsInput!
  $condition: ModelUserConceptsConditionInput
) {
  updateUserConcepts(input: $input, condition: $condition) {
    id
    defaultConcept
    concepts
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserConceptsMutationVariables,
  APITypes.UpdateUserConceptsMutation
>;
export const deleteUserConcepts = /* GraphQL */ `mutation DeleteUserConcepts(
  $input: DeleteUserConceptsInput!
  $condition: ModelUserConceptsConditionInput
) {
  deleteUserConcepts(input: $input, condition: $condition) {
    id
    defaultConcept
    concepts
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserConceptsMutationVariables,
  APITypes.DeleteUserConceptsMutation
>;
export const createAdminRole = /* GraphQL */ `mutation CreateAdminRole(
  $input: CreateAdminRoleInput!
  $condition: ModelAdminRoleConditionInput
) {
  createAdminRole(input: $input, condition: $condition) {
    id
    name
    description
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAdminRoleMutationVariables,
  APITypes.CreateAdminRoleMutation
>;
export const updateAdminRole = /* GraphQL */ `mutation UpdateAdminRole(
  $input: UpdateAdminRoleInput!
  $condition: ModelAdminRoleConditionInput
) {
  updateAdminRole(input: $input, condition: $condition) {
    id
    name
    description
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAdminRoleMutationVariables,
  APITypes.UpdateAdminRoleMutation
>;
export const deleteAdminRole = /* GraphQL */ `mutation DeleteAdminRole(
  $input: DeleteAdminRoleInput!
  $condition: ModelAdminRoleConditionInput
) {
  deleteAdminRole(input: $input, condition: $condition) {
    id
    name
    description
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAdminRoleMutationVariables,
  APITypes.DeleteAdminRoleMutation
>;
export const createAdminGroup = /* GraphQL */ `mutation CreateAdminGroup(
  $input: CreateAdminGroupInput!
  $condition: ModelAdminGroupConditionInput
) {
  createAdminGroup(input: $input, condition: $condition) {
    id
    name
    description
    roles
    users
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAdminGroupMutationVariables,
  APITypes.CreateAdminGroupMutation
>;
export const updateAdminGroup = /* GraphQL */ `mutation UpdateAdminGroup(
  $input: UpdateAdminGroupInput!
  $condition: ModelAdminGroupConditionInput
) {
  updateAdminGroup(input: $input, condition: $condition) {
    id
    name
    description
    roles
    users
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAdminGroupMutationVariables,
  APITypes.UpdateAdminGroupMutation
>;
export const deleteAdminGroup = /* GraphQL */ `mutation DeleteAdminGroup(
  $input: DeleteAdminGroupInput!
  $condition: ModelAdminGroupConditionInput
) {
  deleteAdminGroup(input: $input, condition: $condition) {
    id
    name
    description
    roles
    users
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAdminGroupMutationVariables,
  APITypes.DeleteAdminGroupMutation
>;
export const createAccount = /* GraphQL */ `mutation CreateAccount(
  $input: CreateAccountInput!
  $condition: ModelAccountConditionInput
) {
  createAccount(input: $input, condition: $condition) {
    id
    domain
    siteTitle
    guestsCount
    tagline
    description
    siteAddress
    defaultLanguage
    languages
    features
    status
    socialLinks
    currency
    merchantVersion
    merchantID
    merchantIframe
    merchantIntegrationNumber
    merchantAPIKey
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAccountMutationVariables,
  APITypes.CreateAccountMutation
>;
export const updateAccount = /* GraphQL */ `mutation UpdateAccount(
  $input: UpdateAccountInput!
  $condition: ModelAccountConditionInput
) {
  updateAccount(input: $input, condition: $condition) {
    id
    domain
    siteTitle
    guestsCount
    tagline
    description
    siteAddress
    defaultLanguage
    languages
    features
    status
    socialLinks
    currency
    merchantVersion
    merchantID
    merchantIframe
    merchantIntegrationNumber
    merchantAPIKey
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAccountMutationVariables,
  APITypes.UpdateAccountMutation
>;
export const deleteAccount = /* GraphQL */ `mutation DeleteAccount(
  $input: DeleteAccountInput!
  $condition: ModelAccountConditionInput
) {
  deleteAccount(input: $input, condition: $condition) {
    id
    domain
    siteTitle
    guestsCount
    tagline
    description
    siteAddress
    defaultLanguage
    languages
    features
    status
    socialLinks
    currency
    merchantVersion
    merchantID
    merchantIframe
    merchantIntegrationNumber
    merchantAPIKey
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAccountMutationVariables,
  APITypes.DeleteAccountMutation
>;
export const createReservation = /* GraphQL */ `mutation CreateReservation(
  $input: CreateReservationInput!
  $condition: ModelReservationConditionInput
) {
  createReservation(input: $input, condition: $condition) {
    id
    conceptId
    operaHotelId
    guestName
    guestPhoneNumber
    guestEmail
    confirmationNumber
    eventPrimaryKey
    status
    arrivalDate
    departureDate
    isCheckInGreetingSent
    isCheckOutGreetingSent
    isEmailSent
    emailNotSentReason
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReservationMutationVariables,
  APITypes.CreateReservationMutation
>;
export const updateReservation = /* GraphQL */ `mutation UpdateReservation(
  $input: UpdateReservationInput!
  $condition: ModelReservationConditionInput
) {
  updateReservation(input: $input, condition: $condition) {
    id
    conceptId
    operaHotelId
    guestName
    guestPhoneNumber
    guestEmail
    confirmationNumber
    eventPrimaryKey
    status
    arrivalDate
    departureDate
    isCheckInGreetingSent
    isCheckOutGreetingSent
    isEmailSent
    emailNotSentReason
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReservationMutationVariables,
  APITypes.UpdateReservationMutation
>;
export const deleteReservation = /* GraphQL */ `mutation DeleteReservation(
  $input: DeleteReservationInput!
  $condition: ModelReservationConditionInput
) {
  deleteReservation(input: $input, condition: $condition) {
    id
    conceptId
    operaHotelId
    guestName
    guestPhoneNumber
    guestEmail
    confirmationNumber
    eventPrimaryKey
    status
    arrivalDate
    departureDate
    isCheckInGreetingSent
    isCheckOutGreetingSent
    isEmailSent
    emailNotSentReason
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteReservationMutationVariables,
  APITypes.DeleteReservationMutation
>;
export const createRating = /* GraphQL */ `mutation CreateRating(
  $input: CreateRatingInput!
  $condition: ModelRatingConditionInput
) {
  createRating(input: $input, condition: $condition) {
    id
    conceptId
    operaHotelId
    guestName
    guestPhoneNumber
    conversationId
    reservationId
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRatingMutationVariables,
  APITypes.CreateRatingMutation
>;
export const updateRating = /* GraphQL */ `mutation UpdateRating(
  $input: UpdateRatingInput!
  $condition: ModelRatingConditionInput
) {
  updateRating(input: $input, condition: $condition) {
    id
    conceptId
    operaHotelId
    guestName
    guestPhoneNumber
    conversationId
    reservationId
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRatingMutationVariables,
  APITypes.UpdateRatingMutation
>;
export const deleteRating = /* GraphQL */ `mutation DeleteRating(
  $input: DeleteRatingInput!
  $condition: ModelRatingConditionInput
) {
  deleteRating(input: $input, condition: $condition) {
    id
    conceptId
    operaHotelId
    guestName
    guestPhoneNumber
    conversationId
    reservationId
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRatingMutationVariables,
  APITypes.DeleteRatingMutation
>;
export const createConversation = /* GraphQL */ `mutation CreateConversation(
  $input: CreateConversationInput!
  $condition: ModelConversationConditionInput
) {
  createConversation(input: $input, condition: $condition) {
    id
    conceptId
    guestPhoneNumber
    guestEmail
    whatsappId
    guestName
    reservationId
    confirmationNumber
    status
    assignedToId
    assignedToName
    lastMessageAt
    lastMessagePreview
    unreadCount
    messageCount
    tags
    feedback
    feedbackScore
    feedbackSubmittedAt
    source
    channel
    language
    notes
    deleted
    createdAt
    updatedAt
    createdByID
    createdByName
    messages {
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateConversationMutationVariables,
  APITypes.CreateConversationMutation
>;
export const updateConversation = /* GraphQL */ `mutation UpdateConversation(
  $input: UpdateConversationInput!
  $condition: ModelConversationConditionInput
) {
  updateConversation(input: $input, condition: $condition) {
    id
    conceptId
    guestPhoneNumber
    guestEmail
    whatsappId
    guestName
    reservationId
    confirmationNumber
    status
    assignedToId
    assignedToName
    lastMessageAt
    lastMessagePreview
    unreadCount
    messageCount
    tags
    feedback
    feedbackScore
    feedbackSubmittedAt
    source
    channel
    language
    notes
    deleted
    createdAt
    updatedAt
    createdByID
    createdByName
    messages {
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateConversationMutationVariables,
  APITypes.UpdateConversationMutation
>;
export const deleteConversation = /* GraphQL */ `mutation DeleteConversation(
  $input: DeleteConversationInput!
  $condition: ModelConversationConditionInput
) {
  deleteConversation(input: $input, condition: $condition) {
    id
    conceptId
    guestPhoneNumber
    guestEmail
    whatsappId
    guestName
    reservationId
    confirmationNumber
    status
    assignedToId
    assignedToName
    lastMessageAt
    lastMessagePreview
    unreadCount
    messageCount
    tags
    feedback
    feedbackScore
    feedbackSubmittedAt
    source
    channel
    language
    notes
    deleted
    createdAt
    updatedAt
    createdByID
    createdByName
    messages {
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteConversationMutationVariables,
  APITypes.DeleteConversationMutation
>;
export const createMessage = /* GraphQL */ `mutation CreateMessage(
  $input: CreateMessageInput!
  $condition: ModelMessageConditionInput
) {
  createMessage(input: $input, condition: $condition) {
    id
    conceptId
    conversationId
    whatsappMessageId
    direction
    messageType
    text
    status
    whatsappTimestamp
    replyToMessageId
    replyToMessage {
      id
      conceptId
      conversationId
      whatsappMessageId
      direction
      messageType
      text
      status
      whatsappTimestamp
      replyToMessageId
      forwarded
      senderId
      senderName
      senderType
      readAt
      deliveredAt
      errorCode
      errorMessage
      metadata
      deleted
      createdAt
      updatedAt
      __typename
    }
    forwarded
    senderId
    senderName
    senderType
    readAt
    deliveredAt
    errorCode
    errorMessage
    metadata
    deleted
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMessageMutationVariables,
  APITypes.CreateMessageMutation
>;
export const updateMessage = /* GraphQL */ `mutation UpdateMessage(
  $input: UpdateMessageInput!
  $condition: ModelMessageConditionInput
) {
  updateMessage(input: $input, condition: $condition) {
    id
    conceptId
    conversationId
    whatsappMessageId
    direction
    messageType
    text
    status
    whatsappTimestamp
    replyToMessageId
    replyToMessage {
      id
      conceptId
      conversationId
      whatsappMessageId
      direction
      messageType
      text
      status
      whatsappTimestamp
      replyToMessageId
      forwarded
      senderId
      senderName
      senderType
      readAt
      deliveredAt
      errorCode
      errorMessage
      metadata
      deleted
      createdAt
      updatedAt
      __typename
    }
    forwarded
    senderId
    senderName
    senderType
    readAt
    deliveredAt
    errorCode
    errorMessage
    metadata
    deleted
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMessageMutationVariables,
  APITypes.UpdateMessageMutation
>;
export const deleteMessage = /* GraphQL */ `mutation DeleteMessage(
  $input: DeleteMessageInput!
  $condition: ModelMessageConditionInput
) {
  deleteMessage(input: $input, condition: $condition) {
    id
    conceptId
    conversationId
    whatsappMessageId
    direction
    messageType
    text
    status
    whatsappTimestamp
    replyToMessageId
    replyToMessage {
      id
      conceptId
      conversationId
      whatsappMessageId
      direction
      messageType
      text
      status
      whatsappTimestamp
      replyToMessageId
      forwarded
      senderId
      senderName
      senderType
      readAt
      deliveredAt
      errorCode
      errorMessage
      metadata
      deleted
      createdAt
      updatedAt
      __typename
    }
    forwarded
    senderId
    senderName
    senderType
    readAt
    deliveredAt
    errorCode
    errorMessage
    metadata
    deleted
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMessageMutationVariables,
  APITypes.DeleteMessageMutation
>;
export const createMessaging = /* GraphQL */ `mutation CreateMessaging(
  $input: CreateMessagingInput!
  $condition: ModelMessagingConditionInput
) {
  createMessaging(input: $input, condition: $condition) {
    id
    conceptId
    operaHotelId
    trigger
    channel
    description
    precedence
    delayMinutes
    subject
    messageTemplate
    header
    footer
    templateName
    templateLanguage
    sendRatingAfter
    ratingLink
    isActive
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    updatedByID
    updatedByName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMessagingMutationVariables,
  APITypes.CreateMessagingMutation
>;
export const updateMessaging = /* GraphQL */ `mutation UpdateMessaging(
  $input: UpdateMessagingInput!
  $condition: ModelMessagingConditionInput
) {
  updateMessaging(input: $input, condition: $condition) {
    id
    conceptId
    operaHotelId
    trigger
    channel
    description
    precedence
    delayMinutes
    subject
    messageTemplate
    header
    footer
    templateName
    templateLanguage
    sendRatingAfter
    ratingLink
    isActive
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    updatedByID
    updatedByName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMessagingMutationVariables,
  APITypes.UpdateMessagingMutation
>;
export const deleteMessaging = /* GraphQL */ `mutation DeleteMessaging(
  $input: DeleteMessagingInput!
  $condition: ModelMessagingConditionInput
) {
  deleteMessaging(input: $input, condition: $condition) {
    id
    conceptId
    operaHotelId
    trigger
    channel
    description
    precedence
    delayMinutes
    subject
    messageTemplate
    header
    footer
    templateName
    templateLanguage
    sendRatingAfter
    ratingLink
    isActive
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    updatedByID
    updatedByName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMessagingMutationVariables,
  APITypes.DeleteMessagingMutation
>;
export const createFeature = /* GraphQL */ `mutation CreateFeature(
  $input: CreateFeatureInput!
  $condition: ModelFeatureConditionInput
) {
  createFeature(input: $input, condition: $condition) {
    id
    name
    icon
    slug
    precedence
    parent
    private
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFeatureMutationVariables,
  APITypes.CreateFeatureMutation
>;
export const updateFeature = /* GraphQL */ `mutation UpdateFeature(
  $input: UpdateFeatureInput!
  $condition: ModelFeatureConditionInput
) {
  updateFeature(input: $input, condition: $condition) {
    id
    name
    icon
    slug
    precedence
    parent
    private
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFeatureMutationVariables,
  APITypes.UpdateFeatureMutation
>;
export const deleteFeature = /* GraphQL */ `mutation DeleteFeature(
  $input: DeleteFeatureInput!
  $condition: ModelFeatureConditionInput
) {
  deleteFeature(input: $input, condition: $condition) {
    id
    name
    icon
    slug
    precedence
    parent
    private
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFeatureMutationVariables,
  APITypes.DeleteFeatureMutation
>;
